<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs$ | async" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper flex flex-col gap-4">
  <h1 class="mat-headline-4 !mb-0">Opening Hours</h1>
  <pr-content-container>
    <div
      *ngFor="let row of openingHoursByDay$ | async; trackBy: trackByDay"
      class="day flex items-center gap-2"
    >
      <h3 class="w-1/5">{{ row.dayOfWeek | titlecase }}</h3>
      <h3 class="flex-1">
        <ng-container *ngIf="row.openingTimes; else closed">
          {{ row.openingTimes.from | timeFormat }} to
          {{ row.openingTimes.to | timeFormat }}
        </ng-container>
        <ng-template #closed>Closed</ng-template>
      </h3>
      <pt-buttons-container>
        <button
          mat-stroked-button
          [disabled]="row.openingTimes === undefined"
          (click)="delete(row.dayOfWeek)"
        >
          Set as Closed
        </button>
        <button mat-flat-button color="primary" (click)="edit(row.dayOfWeek)">
          Edit
        </button>
      </pt-buttons-container>
    </div>
  </pr-content-container>
</div>
